import React from 'react'
import { makeStyles, Input } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import shiftIconSVG from '../../assets/icons/shift-icon.svg'
import classroomPeoplesSVG from '../../assets/icons/classroom-peoples-icon.svg'
import soloPeopleSVG from '../../assets/icons/solo-people-icon.svg'
import editSVG from '../../assets/icons/edit-pencil.svg'
import confirmationSVG from '../../assets/icons/status-confirmation.svg'
import archiveSVG from '../../assets/icons/archive-room.svg'
import illustrationArchive from '../../assets/icons/illustration-archive-room.svg'
import outlinedWarningSVG from '../../assets/icons/information-icon.svg'

import { shiftOptions } from '../../utils/constants'
import Button from '../button/Button'
import Modal from '../modal/Modal'
import StyledSVG from '../shared/StyledSVG'
import { occupationsObject } from '../../utils/dicts'
import mediationAvatarSVG from '../../assets/icons/mediation-message.svg'
import groupRoomIcon from '../../assets/icons/message-group.svg'
import UserAvatar from '../shared/UserAvatar'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    padding: 18,
    borderLeft: '1px solid #CED6E0',
    position: 'relative',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px'
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px',
      background: 'rgba(173, 184, 204, 1)'
    }
  },
  close_section: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8,
    '& h1': {
      color: '#4D5E80',
      fontWeight: 600,
      fontSize: 18
    }
  },
  profile_section: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16
  },
  room_identification: {
    marginBottom: 18,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    '& .room_name': {
      margin: 0,
      fontSize: 18,
      fontWeight: 600
    },
    '& .room_description': {
      color: '#9F9F9F',
      fontSize: 14,
      fontWeight: 400
    }
  },
  horizontal_bar: {
    height: 0,
    width: '100%',
    borderBottom: '1px solid #868E964D'
  },
  archive_room_btn: {
    marginTop: 24,
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EF7C8F',
    '& p': {
      fontSize: '14px',
      fontWeight: 700,
      textTransform: 'none',
      margin: '0px 0px 0px 8px'
    },
    width: '90%',
    height: 48,
    padding: '18px',
    columnGap: 8,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7C8F'
    }
  },
  room_participants_section: {
    margin: '18px 0px 18px 0px',
    minHeight: 100,
    maxHeight: 150,
    height: 'auto',
    overflowY: 'scroll',
    resize: 'none',
    overflow: 'hidden'
  },
  edit_room_participants: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
    '& svg': {
      fill: '#386093'
    },
    '& p': {
      fontSize: 14,
      fontWeight: 500,
      color: '#386093'
    }
  },
  room_participant: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& p': {
      fontWeight: 500,
      fontSize: 10
    }
  },
  room_participants: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column'
  },
  close_room: {
    cursor: 'pointer',
    backgroundColor: '#EF7B8E',
    borderRadius: 8,
    width: 220,
    gap: 8,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      fontSize: 14,
      fontWeight: 700
    }
  },
  close_room_wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    bottom: 50
  },
  confirm_btn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    width: 165,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  participant_infos: {
    margin: '12px 0px 18px 0px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  p_info: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& h1': {
      fontWeight: 600,
      fontSize: 16,
      color: '#555555',
      margin: 0
    }
  },
  p_info_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    '& .items': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: 4,
      '& p': {
        paddingLeft: 25,
        fontWeight: 400,
        fontSize: 14,
        margin: 0
      }
    }
  },
  room_description: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    margin: '12px 0px 18px 0px',
    '& h1': {
      fontWeight: 600,
      fontSize: 16,
      margin: 0
    },
    '& p': {
      fontWeight: 400,
      fontSize: 12,
      margin: 0,
      minHeight: 50,
      maxHeight: 80,
      height: 'auto',
      overflowY: 'scroll',
      resize: 'none',
      overflow: 'hidden',
      wordBreak: 'break-word'
    }
  },
  name_section_wrapper: {
    display: 'flex',
    columnGap: 8,
    alignItems: 'center',
    '& input.room_name': {
      color: '#555555',
      fontFamily: 'Montserrat, Source Sans Pro',
      margin: 0,
      fontSize: 18,
      fontWeight: 600,
      border: 'none',
      outline: 'none',
      background: 'transparent',
      padding: 0
    },
    '& .edit_icon': {
      cursor: 'pointer',
      '& path': {
        stroke: '#9F9F9F'
      }
    },
    '& .confirmation_icon': {
      cursor: 'pointer'
    }
  },
  archive_modal: {
    fontFamily: 'Montserrat, Source Sans Pro',
    borderRadius: 16,
    padding: '48px 24px',
    width: 750,
    minHeight: 800
  },
  text_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: 20,
    '& .title': {
      color: '#386093',
      fontWeight: 700,
      fontSize: 24,
      margin: 0
    },
    '& .description': {
      fontWeight: 400,
      fontSize: 16,
      margin: 0,
      maxWidth: '90%'
    }
  },
  archive_rooms_path: {
    marginTop: 40,
    width: 400,
    height: 70,
    borderRadius: 8,
    backgroundColor: '#EFF4FA',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      color: '#386093',
      fontWeight: 400,
      fontSize: 14,
      margin: 0,
      maxWidth: 250,
      '& span': {
        fontWeight: 700
      }
    }
  },
  btns_wrapper: {
    display: 'flex',
    columnGap: 16,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 42
  },
  cancel_btn: {
    width: 160,
    border: '1px solid #EF7C8F',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    color: '#EF7C8F',
    borderRadius: 8,
    '&:hover': {
      border: '1px solid #EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600
  },
  confirm_archive_btn: {
    backgroundColor: '#386093',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    '& .MuiButton-label': {
      textTransform: 'none'
    }
  },
  archived_reason: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '32px 0px 24px 0px'
  },
  archived_input_wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: 400,
    '& p.label': {
      fontWeight: 600,
      fontSize: 14,
      color: '#386093',
      margin: 0
    },
    marginBottom: 8
  },
  archived_warning: {
    width: 400,
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: 8,
    '& p': {
      margin: 0,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '120%',
      textAlign: 'left'
    },
    '& svg': {
      '& path': {
        fill: '#386093'
      }
    }
  },
  archived_input: {
    '& .MuiInputBase-input::placeholder': {
      color: '#868E96',
      opacity: 1,
      fontWeight: 500
    },
    alignItems: 'flex-start',
    '& input, & textarea': {
      paddingTop: 8,
      paddingLeft: 8
    },
    width: '100%',
    height: 85,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    border: '1px solid #ADB8CC',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px'
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px',
      background: 'rgba(173, 184, 204, 1)'
    }
  }
}))

const RoomDetailsView = props => {
  const {
    setRoomDetails,
    currentRoom,
    currentUser,
    editRoomRSPA,
    updateGroupRoomReducer,
    filterArchived,
    showAlertMessage,
    isAdmin,
    canManageRooms,
    archiveRoomsFeatureFlag,
    updateCurrentRoom
  } = props
  const [archiveRoomModal, setArchiveRoomModal] = React.useState({
    open: false,
    reason: ''
  })
  const [roomData, setRoomData] = React.useState({
    name: '',
    photo: null,
    description: '',
    otherParticipant: null
  })
  const classes = useStyles()

  const uniqueShifts = [
    ...new Set(
      roomData.otherParticipant?.user?.classrooms
        ?.map(c => c.shift)
        .filter(shift => shift && shift !== 'undefined')
    )
  ]
  const [editingName, setEditingName] = React.useState({
    editing: false,
    value: ''
  })
  const nameRef = React.useRef(null)
  const archivedRoom = currentRoom.status === 'archived'

  React.useEffect(
    () => {
      let roomState
      if (currentRoom?.room_type === 'private') {
        const otherParticipant = currentRoom?.room_participants?.find(
          item =>
            +item?.user?.fractal_id !== +currentUser?.attributes.fractal_id
        )
        roomState = {
          name: otherParticipant?.user?.name,
          description: occupationsObject?.[otherParticipant?.occupation_name],
          otherParticipant: otherParticipant
        }
      } else {
        const name = currentRoom?.name
        roomState = {
          name,
          description: `Grupo - ${
            currentRoom.room_participants?.length
          } membros`,
          photo: currentRoom?.mediation_message_id
            ? mediationAvatarSVG
            : currentRoom.cover_image_url
              ? currentRoom.cover_image_url
              : groupRoomIcon
        }
      }
      setRoomData(prev => ({
        ...prev,
        ...roomState
      }))
      setEditingName(prev => ({ ...prev, value: roomState.name }))
    },
    [currentRoom]
  )

  const handleEditClick = () => {
    setEditingName(prev => ({ ...prev, editing: true }))
    // uso de micro/macrotasks inves de useEffect
    setTimeout(() => nameRef.current?.focus(), 0)
  }

  const handleEditClose = newName => {
    setEditingName(prev => ({
      value: newName || roomData?.name,
      editing: false
    }))
  }

  const handleFinishEditName = async () => {
    if (editingName.value?.length > 0) {
      await editRoomRSPA({
        id: currentRoom.id,
        data: { name: editingName.value }
      })
        .then(res => {
          updateGroupRoomReducer(res.data)
          handleEditClose(res.data.name)
        })
        .catch(error => {
          handleEditClose()
          showAlertMessage('Erro ao editar sala.', 'error')
          console.error(error)
        })
    }
  }

  const handleCloseRoomDetails = () => {
    handleEditClose()
    setRoomDetails(prev => ({ ...prev, isOpen: false }))
  }

  const handleArchivedReason = event => {
    setArchiveRoomModal(prev => ({ ...prev, reason: event.target.value }))
  }

  const handleCloseArchiveModal = () => {
    setArchiveRoomModal(prev => ({ ...prev, open: false }))
  }

  const archiveRoom = async () => {
    await editRoomRSPA({
      id: currentRoom.id,
      data: {
        status: 1,
        archived_reason: archiveRoomModal.reason,
        archived_by: currentUser.attributes.fractal_id
      }
    })
      .then(res => {
        handleCloseArchiveModal()
        updateCurrentRoom()
        filterArchived(currentRoom.id)
      })
      .catch(error => {
        handleCloseArchiveModal()
        showAlertMessage('Erro ao arquivar sala.', 'error')
        console.error(error)
      })
  }

  return (
    <div className={classes.root}>
      <div className={classes.close_section}>
        <CloseIcon
          style={{ cursor: 'pointer' }}
          onClick={() => handleCloseRoomDetails()}
        />
        <h1>Dados da conversa</h1>
      </div>
      <div className={classes.profile_section}>
        <UserAvatar
          avatarStyle={{
            width: 130,
            height: 130
          }}
          avatarUrl={roomData.photo}
          userName={roomData.name}
          withoutUserName
        />
        <div className={classes.room_identification}>
          {editingName.editing ? (
            <div className={classes.name_section_wrapper}>
              <input
                id={'edit_room_name'}
                ref={nameRef}
                className='room_name'
                value={editingName?.value}
                onChange={e =>
                  setEditingName(prev => ({ ...prev, value: e.target.value }))
                }
                onKeyDown={e => {
                  if (e.key === 'Enter') handleFinishEditName()
                  if (e.key === 'Escape') handleEditClose()
                }}
              />
              <StyledSVG
                className='confirmation_icon'
                onClick={() => handleFinishEditName()}
                src={confirmationSVG}
                width={16}
                height={16}
              />
            </div>
          ) : (
            <div className={classes.name_section_wrapper}>
              <h1 className='room_name'>{roomData.name}</h1>
              {isAdmin &&
                currentRoom.origin_id === currentUser.attributes.fractal_id && (
                  <StyledSVG
                    className='edit_icon'
                    onClick={handleEditClick}
                    src={editSVG}
                    width={16}
                    height={16}
                  />
                )}
            </div>
          )}
          <span className='room_description'>{roomData.description}</span>
        </div>
      </div>
      {currentRoom.room_type === 'private' && (
        <>
          <div className={classes.participant_infos}>
            {roomData?.otherParticipant?.user?.children?.length > 0 && (
              <div className={classes.p_info_wrapper}>
                <div className={classes.p_info}>
                  <StyledSVG src={soloPeopleSVG} width={18} height={18} />
                  <h1>Aluno</h1>
                </div>
                <div className='items'>
                  {roomData.otherParticipant?.user.children.map(item => {
                    return <p key={item.id}>{item.name}</p>
                  })}
                </div>
              </div>
            )}
            {roomData?.otherParticipant?.user?.classrooms?.length > 0 && (
              <div className={classes.p_info_wrapper}>
                <div className={classes.p_info}>
                  <StyledSVG src={classroomPeoplesSVG} width={18} height={18} />
                  <h1>Turma</h1>
                </div>
                <div className='items'>
                  {roomData.otherParticipant?.user?.classrooms.map(item => {
                    return <p key={item.id}>{item.name}</p>
                  })}
                </div>
              </div>
            )}
            {roomData?.otherParticipant?.user?.classrooms?.length > 0 && (
              <div className={classes.p_info_wrapper}>
                <div className={classes.p_info}>
                  <StyledSVG src={shiftIconSVG} width={18} height={18} />
                  <h1>Turno</h1>
                </div>
                <div className='items'>
                  {uniqueShifts.map(item => {
                    return (
                      <p key={item.id}>
                        {shiftOptions?.find(sft => sft?.value === item)?.label}
                      </p>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        </>
      )}
      {currentRoom.room_type === 'group' && (
        <>
          {currentRoom.description && (
            <div className={classes.room_description}>
              <h1>Descrição</h1>
              <p>{currentRoom.description}</p>
            </div>
          )}
          <div className={classes.horizontal_bar} />
          <div className={classes.room_participants_section}>
            {/* <div className={classes.edit_room_participants}>
              <p>Editar</p>
              <ArrowBackIos style={{transform: 'rotate(180deg)'}}/>
            </div> */}
            <div
              style={{
                minHeight: currentRoom.room_participants.length / 2 * 35
              }}
              className={classes.room_participants}
            >
              {currentRoom.room_participants.length > 0 &&
                currentRoom.room_participants.map(item => {
                  return (
                    <div key={item.id} className={classes.room_participant}>
                      <UserAvatar
                        avatarStyle={{
                          width: 24,
                          height: 24
                        }}
                        userName={item?.user?.name}
                        withoutUserName
                      />
                      <p>{item?.user?.name}</p>
                    </div>
                  )
                })}
            </div>
          </div>
        </>
      )}
      {archiveRoomsFeatureFlag &&
        canManageRooms &&
        !archivedRoom && (
          <>
            <div className={classes.horizontal_bar} />
            <Button
              onClick={() =>
                setArchiveRoomModal(prev => ({ ...prev, open: true }))
              }
              className={classes.archive_room_btn}
            >
              <StyledSVG height={18} width={18} src={archiveSVG} />
              <p>Arquivar conversa</p>
            </Button>
          </>
        )}
      <Modal
        disablePadding
        open={archiveRoomModal.open}
        handleClose={() => handleCloseArchiveModal()}
      >
        <div className={classes.archive_modal}>
          <StyledSVG src={illustrationArchive} width={440} height={280} />
          <div className={classes.text_wrapper}>
            <h1 className='title'>Arquivar essa conversa?</h1>
            <p className='description'>
              Ao arquivar, esta conta será removida da lista principal e não
              poderá ser restaurada depois.
            </p>
          </div>
          <div className={classes.archived_reason}>
            <div className={classes.archived_input_wrapper}>
              <p className='label'>*Motivo do arquivamento</p>
              <Input
                disableUnderline
                multiline
                classes={{ root: classes.archived_input }}
                placeholder='Descreva brevemente o motivo..'
                onChange={handleArchivedReason}
                value={archiveRoomModal.reason}
              />
            </div>
            <div className={classes.archived_warning}>
              <StyledSVG src={outlinedWarningSVG} width={18} height={18} />
              <p>
                Essa informação será usada apenas para controle administrativo
              </p>
            </div>
            <div className={classes.archive_rooms_path}>
              <p>
                Você ainda poderá ver o histórico em{' '}
                <span>{'Mensagens > Arquivadas'}</span>
              </p>
            </div>
          </div>
          <div className={classes.btns_wrapper}>
            <Button
              onClick={() => handleCloseArchiveModal()}
              type='button'
              variant='outlined'
              className={classes.cancel_btn}
            >
              Cancelar
            </Button>
            <Button
              disabled={archiveRoomModal.reason?.length < 1}
              onclick={() => archiveRoom()}
              className={classes.confirm_archive_btn}
            >
              Arquivar conversa
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default RoomDetailsView
